// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousel-controls_wrapper__KNd7w"};